/**
 * 顶部栏组件
 */
import React from 'react';
import { Layout, Button, Avatar, Dropdown, Space, Typography } from 'antd';
import type { MenuProps } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import ThemeSwitch from '../ThemeSwitch';

const { Header } = Layout;
const { Text } = Typography;

interface HeaderBarProps {
  collapsed: boolean;
  isMobile: boolean;
  containerPadding: number;
  userName?: string;
  onToggleCollapse: () => void;
  onLogout: () => void;
}

export const HeaderBar: React.FC<HeaderBarProps> = ({
  collapsed,
  isMobile,
  containerPadding,
  userName,
  onToggleCollapse,
  onLogout,
}) => {
  // 用户下拉菜单
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人信息',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      danger: true,
      onClick: onLogout,
    },
  ];

  return (
    <Header
      style={{
        padding: `0 ${containerPadding}px`,
        background: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #e2e8f0',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        height: isMobile ? 56 : 64,
      }}
    >
      <Space>
        {!isMobile && (
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggleCollapse}
            style={{ fontSize: 16 }}
          />
        )}
      </Space>

      <Space size="middle">
        <ThemeSwitch />
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar 
              style={{ backgroundColor: '#1677ff' }} 
              icon={<UserOutlined />}
              size={isMobile ? 'small' : 'default'}
            />
            {!isMobile && (
              <Text>{userName || '用户'}</Text>
            )}
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};
